import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { formatDate } from 'ngx-bootstrap/chronos';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { AtributosIrfe } from 'src/app/shared/models/atributos-irfe.model';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { ProjetoPermission } from '../../models/projeto-permission.model';
import { IrfeProjetoService } from '../../services/irfe-projeto.service';
import { NavigationService } from '../../services/navigation.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { IrfeProjeto } from './../../models/irfe-projeto.model';

@Component({
  selector: 'app-detalhe-irfe-edit',
  templateUrl: './detalhe-irfe-edit.component.html',
  styleUrls: ['./detalhe-irfe-edit.component.scss']
})
export class DetalheIrfeEditComponent extends BaseFormComponent<IrfeProjeto> implements OnInit {

  idProjeto: number;
  actionLabel: string = 'Novo';
  irfeProjeto: IrfeProjeto;
  attrList: AtributosIrfe;
  audit: AtualizacoesAudit;
  isSuspensionClause: boolean;
  infoProjeto: ProjetoCadastro;
  canSave: boolean = true;
  values_transfer_type_id: any;
  values_identifier_type_id: any;
  values_operational_status: string;
  values_suspension_clause: string;
  values_transfer_type_id2: string;
  sectorialist: string;
  funding_user_cpf: string;
  global_value: string;
  permissions: ProjetoPermission;

  constructor(
    public activatedRoute: ActivatedRoute,
    private myService: IrfeProjetoService,
    private fb: FormBuilder,
    public maskService: MaskService,
    private navigation: NavigationService,
    private pesquisaGeralService: PesquisaGeralService,

  ) {
    super(activatedRoute);
  }

  ngOnInit() {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      //atributos de lista
      this.attrList = this.activatedRoute.snapshot.data["listAtributosIrfe"];
      this.sectorialist = this.attrList.sectorialist;
      this.funding_user_cpf = this.attrList.funding_user_cpf;
      this.values_transfer_type_id = this.attrList.transfer_type_id;
      this.values_operational_status = this.attrList.operational_status;
      this.values_suspension_clause = this.attrList.suspension_clause;
      this.values_transfer_type_id2 = this.attrList.transfer_type_2_id;
      this.values_identifier_type_id = [{id:"siconv_id",label:"Transferegov"},{id:"federal_identifier",label:"Outro sistema federal"}];
      this.initForm();
      this.loaded();
    });
    
    // if( !this.permissions.edit_actived ){
    //   this.msgError("Acesso negado.","Erro na Solicitação");
    //   this.navigation.replace([`projetos/projeto/${this.idProjeto}/cadastro`]);
    // }
  }

  initForm() {
    this.form = this.fb.group({
      ds_object: ['', [Validators.required]],
      ds_target: ['', [Validators.required]],
      ds_grantor: ['', [Validators.required]],
      ds_convenient: ['', [Validators.required]],
      dt_start: ['', [Validators.required]],
      dt_end: ['', [Validators.required]],
      days_accountability: ['60', [Validators.required]],
      dt_accountability: [{ value: '', disabled: true }],
      transfer_value: ['0,00', /*[Validators.required]*/],
      counterpart_value: ['0,00', /*[Validators.required]*/],
      authorized_income_value: ['0,00',  /*[Validators.required]*/],
      global_value: new FormControl({ value: '0,00', disabled: true }),
      siconv_id: [''],
      federal_identifier: [''],
      identifier_type_id: ['', [Validators.required]],
      identifier_type_value: ['', [Validators.required]],
      fpe_identifier: [''],
      transfer_type_id: ['1', [Validators.required]],
      transfer_type_id2: [null],
      operational_status_id: ['1', [Validators.required]],
      suspension_clause_id: ['0', [Validators.required]],
      dt_suspension: [''],
      sectorialist: [''],
      irfe_type: new FormArray([]),
    })
    if (this.entity) {
      this.actionLabel = 'Editar';
      this.identificadorGetValue();
      this.form.patchValue(this.entity);

      this.entity?.irfe_type?.forEach((item) => {
        this.getFormArray().push(this.createFormGroup(item))
      })

      this.canSave = this.entity.test1;

      if (!this.canSave) {
        this.form.disable();
      }

      this.funding_user_cpf = this.entity.funding_user_cpf;
      // this.global_value = String(parseFloat((this.form.value.global_value).replace('.','').replace(',','.'))).replace('.',',');

      let value_string = `${this.entity.transfer_value}`;
      if (this.entity.transfer_value == null) {
        value_string = '0';
      }
      this.form.patchValue({});
      this.isSuspensionClause = this.form.value.suspension_clause_id === '1'

      this.audit = {
        irfe_id: this.entity.id
      };

    } else {
      this.myService.summary(this.idProjeto).subscribe({
        next: (res: any) => {
          this.form.get('dt_start').setValue(res.dt_start);
          this.form.get('dt_end').setValue(res.dt_end);

          let days_accountability = this.form.value.days_accountability;
          let dt_accountability = this.addDays(days_accountability, res.dt_end);

          this.form.get('dt_accountability').setValue(dt_accountability);
        },
      })
    }
    this.loaded;
  }

  formValue(field) {
    return this.form.get(field)?.value;
  }

  createFormGroup(value = null) {
    return new FormControl(value, [Validators.required]);
  }

  addNewIrfeType() {
    this.getFormArray().push(this.createFormGroup(1));
  }

  removeIrfeType(index: number) {
    this.getFormArray().removeAt(index);
  }

  getFormArray(): FormArray {
    return this.form.get('irfe_type') as FormArray;
  }

  maskCurrency(event, field) {
    let value = this.maskService.formatarMedidaFisica(event.target?.value, 2, 14);
    this.form.get(field).setValue(value);
    this.setGlobalValue();
  }

  setGlobalValue() {
    let value1 = Number(this.formValue('counterpart_value').replace(/\./g, '').replace(/,/g, '.'));
    let value2 = Number(this.formValue('transfer_value').replace(/\./g, '').replace(/,/g, '.'));
    let value3 = Number(this.formValue('authorized_income_value').replace(/\./g, '').replace(/,/g, '.'));

    this.form.get('global_value').setValue((Number(value1 + value2 + value3)).toLocaleString('pt-BR', { currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  }

  changeSuspensionClause(e): void {
    this.isSuspensionClause = e.id === '1'

    if (!this.isSuspensionClause) {
      this.form.get('dt_suspension').setValue('');
    }
  }

  changeDtSuspension(e): void {
    let days_accountability = parseInt(e.target.value);
    let dt_end = this.form.value.dt_end;

    let dt_accountability = this.addDays(days_accountability, dt_end);

    this.form.get('dt_accountability').setValue(dt_accountability);
  }


  getDataCreate(): IrfeProjeto {
    let data: IrfeProjeto;

    data = Object.assign({}, data, this.form.value);
    
    
    var { identifier_type_id, identifier_type_value}  = data;
    data.siconv_id = identifier_type_id === 'siconv_id'? identifier_type_value : '';
    data.federal_identifier = identifier_type_id === 'federal_identifier'? identifier_type_value : '';     
    
    data.pf_id = this.idProjeto;

    data.sectorialist = this.sectorialist

    if (!this.verificaFormatoData(data.dt_start)) {
      data.dt_start = formatDate(data.dt_start, 'DD/MM/YYYY');
    }
    if (!this.verificaFormatoData(data.dt_end)) {
      data.dt_end = formatDate(data.dt_end, 'DD/MM/YYYY');
    }

    if (data.dt_suspension) {
      if (!this.verificaFormatoData(data.dt_suspension)) {
        data.dt_suspension = formatDate(data.dt_suspension, 'DD/MM/YYYY');
      }
    }
    return data;
  }

  voltar() {
    this.navigation.back([`projetos/projeto/${this.idProjeto}/irfe`]);
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res: IrfeProjeto) => {
              this.msgSuccess('IRFE alterado com sucesso!');
              EventSharedService.get('auditRefresh').emit();
              this.loaded();
            },
            error: (error) => {
              console.log(this.getDataCreate())
              let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
              this.msgError(msg);
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: IrfeProjeto) => {
              this.confirmation('IRFE cadastrado com sucesso!').subscribe(() => {
                this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'irfe', res.id,]);
              })
              this.loaded();
            },
            error: (error) => {
              let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
              this.msgError(msg);
              this.loaded();
            },
          })
        );
      }
    } else {
      this.markAsDirty();
    }
  }

  fieldMessageRequireds(field, index: number): boolean {
    return this.getFormArray().controls[index]?.invalid && this.getFormArray().controls[index]?.dirty;
  }

  fieldErrosFormArray(field, index: number) {
    return this.getFormArray().controls[index]?.errors;
  }
  
  identificadorGetValue(){
    const { siconv_id, federal_identifier } = this.entity;
    this.entity['identifier_type_id'] = siconv_id ? 'siconv_id' : federal_identifier ? 'federal_identifier' : '';
    this.entity['identifier_type_value'] = siconv_id || federal_identifier || '';
  }

  indentificadorChange(field) {
    this.form.get('siconv_id').removeValidators([Validators.required]);
    this.form.get('siconv_id').updateValueAndValidity();
    this.form.get('federal_identifier').removeValidators([Validators.required]);
    this.form.get('federal_identifier').updateValueAndValidity();
    this.form.get(field).addValidators([Validators.required]);
    this.form.get(field).updateValueAndValidity();
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.myService.delete(this.entity?.id).subscribe({
      next: (res) => {
        this.loaded();
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'irfe']);
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error?.message || "Ocorreu um erro ao excluir.")
      }
    });
  }
}
